import styled from 'styled-components';
import { CSVLink } from 'react-csv';

import { colours, fonts } from 'themes/default';

export const StyledDownloadLink = styled(CSVLink)`
  color: ${colours.Shades.BlueShade40};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  white-space: nowrap;
  font-family: ${fonts.fontFamily};
  font-size: 14px;
  line-height: 32px;
  border-radius: 3px;
  font-weight: 600;
  padding: 0 8px 0 8px;
  height: 32px;
  text-align: center;
  background-color: ${colours.Greyscale.White};
  border-color: ${colours.Shades.BlueShade40};
  border-width: 1px;
  border-style: solid;
  margin: 0;
  text-decoration: none;
  position: relative;
  display: inline-block;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${colours.Greyscale.White};
  }
`;

export const StyledDownloadLinkContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 16px 8px;
`;
